import WebFont from 'webfontloader';
import browserDeviceDetect from './functions/browser-device-detect';
import cart from './components/cart';
import { intervalToDuration, parseISO } from 'date-fns';
import IMask from 'imask';
import Glide from '@glidejs/glide';

function closest(el, selector) {
  const matchesSelector = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;

  while (el) {
    if (matchesSelector.call(el, selector)) {
      return el;
    }
    el = el.parentElement;
  }
  return null;
}

const animateBooks = function() {
  let elems;
  let windowHeight;

  function init() {
    elems = document.querySelectorAll('.products-list__product .wrapper');
    for (let i = 0; i < elems.length; i++) {
      elems[i].classList.add('faded-out');
    }
    windowHeight = window.innerHeight;
    addEventHandlers();
    checkPosition();
  }

  function addEventHandlers() {
    window.addEventListener('scroll', checkPosition);
    window.addEventListener('resize', init);
  }

  function checkPosition() {
    for (let i = 0; i < elems.length; i++) {
      const positionFromTop = elems[i].getBoundingClientRect().top;
      if (positionFromTop - windowHeight <= 0) {
        elems[i].classList.remove('faded-out');
        elems[i].classList.add('faded-in');
      } else {
        elems[i].classList.add('faded-out');
        elems[i].classList.remove('faded-in');
      }
    }
  }

  return {
    init
  };
};

// function amountSelect() {
//   const $selects = document.querySelectorAll('.amount-select');
//
//   $selects.forEach(($select) => {
//     const $wrapper = $select.parentNode;
//     const $price = $wrapper.querySelector('.price');
//     const $total = document.getElementById('total');
//     const $delivery = document.getElementById('delivery');
//     const $deleteButton = $wrapper.querySelector('.delete-button');
//     const $buttons = $select.querySelectorAll('.amount-select__buttons button');
//     const $input = $select.querySelector('.input');
//     const max = Number($select.dataset.max) || 10000;
//     const { originalPrice } = $select.dataset;
//
//     const setLoading = (set) => {
//       $wrapper.classList[set ? 'add' : 'remove']('is-loading');
//       if (set) {
//         $input.setAttribute('disabled', 'disabled');
//       } else {
//         $input.removeAttribute('disabled');
//       }
//     };
//     const formatPrice = price => `${Number(price).toLocaleString('hu', {
//       style: 'currency',
//       currency: 'HUF',
//       minimumFractionDigits: 0,
//     })}`;
//
//     // eslint-disable-next-line max-len,no-return-assign
//     const setTotalPrice = (price = null) => $total.innerHTML = formatPrice(price);
//     // eslint-disable-next-line max-len,no-return-assign
//     const setDeliveryPrice = (price = null) => $delivery.innerHTML = formatPrice(price);
//
//     async function handleValueChange(value) {
//       if (Number(value) < 1) return 1;
//       if (Number(value) > max) return max;
//
//       setLoading(true);
//
//       const response = await fetch($input.dataset.url, {
//         method: $input.dataset.method,
//         headers: {
//           Accept: 'application/json',
//           'Content-Type': 'application/json',
//           credentials: 'same-origin',
//         },
//         body: JSON.stringify({ quantity: value }),
//       });
//
//       const { status, data: { total, deliveryPrice } } = await response.json();
//
//       if (status) {
//         const newPrice = Number(originalPrice) * Number(value);
//         $price.innerHTML = formatPrice(newPrice);
//
//         setTotalPrice(total);
//         setDeliveryPrice(deliveryPrice);
//         setLoading(false);
//       }
//
//       $input.value = value;
//
//       return true;
//     }
//
//     async function handleDelete(e, $button) {
//       setLoading(true);
//
//       const response = await fetch($button.dataset.url, {
//         method: $button.dataset.method,
//         headers: {
//           Accept: 'application/json',
//           'Content-Type': 'application/json',
//           credentials: 'same-origin',
//         },
//       });
//
//       const { status, data: { total, deliveryPrice } } = await response.json();
//
//       if (status) {
//         $wrapper.remove();
//
//         const deliveryItem = document.querySelector('.order-form__item-delivery');
//
//         if (deliveryItem && deliveryPrice > 0) {
//           deliveryItem.classList.remove('is-hidden');
//         } else {
//           deliveryItem.classList.add('is-hidden');
//         }
//
//         setTotalPrice(total);
//         setDeliveryPrice(deliveryPrice);
//       }
//     }
//
//     if ($deleteButton) $deleteButton.addEventListener('click', e => handleDelete(e, $deleteButton));
//
//     $input.addEventListener('change', (e) => {
//       e.preventDefault();
//       handleValueChange($input.value);
//     });
//
//     $buttons.forEach(($button, index) => {
//       $button.addEventListener('click', () => {
//         handleValueChange(index ? (Number($input.value) - 1) : (Number($input.value) + 1))
//       });
//     });
//   });
// }

// --- Ready
document.addEventListener('DOMContentLoaded', () => {
  browserDeviceDetect();

  // amountSelect();

  WebFont.load({
    google: {
      families: [ 'Poppins:200,200i,400,400i,700,700i:latin-ext' ]
    }
  });

  // input masks

  const maskInputs = document.querySelectorAll('input[data-mask]');
  if (maskInputs) {
    maskInputs.forEach(input => {
      IMask(input, {
        mask: input.dataset.mask
      });
    });
  }

  // puzzle deadline

  const puzzle = document.querySelector('.puzzle-deadline');
  if (puzzle) {
    const deadline = parseISO(puzzle.dataset.deadline);

    setInterval(function() {
      const result = intervalToDuration({
        start: new Date(),
        end: deadline
      });
      // => { years: 39, months: 2, days: 20, hours: 7, minutes: 5, seconds: 0 }

      if (result) {
        const dayElem = puzzle.querySelector('.day > div');
        if (dayElem) {
          dayElem.innerText = result.days;
        }

        const hourElem = puzzle.querySelector('.hour > div');
        if (hourElem) {
          hourElem.innerText = result.hours;
        }

        const minuteElem = puzzle.querySelector('.minute > div');
        if (minuteElem) {
          minuteElem.innerText = result.minutes;
        }

        const secondElem = puzzle.querySelector('.second > div');
        if (secondElem) {
          secondElem.innerText = result.seconds;
        }
      }
    }, 1000);
  }

  const productList = document.querySelector('.products-list');

  if (productList) {
    animateBooks().init();
  }

  // const orderForm = document.querySelector('form.order-form:not(.unique)');
  //
  // if (orderForm) {
  //   const defaultInputs = document.querySelectorAll('.default-inputs input');
  //   const invoiceInputs = document.querySelectorAll('.invoice-address-form input');
  //   const legalCheckboxes = document.querySelectorAll('.legal-checkboxes input');
  //   const invoiceInputsTrigger = document.getElementById('invoice-address-checkbox');
  //
  //   orderForm.addEventListener('submit', (event) => {
  //     let errors = [];
  //
  //     defaultInputs.forEach((input) => {
  //       const inputField = closest(input, '.field');
  //       if (input.value) {
  //         console.log(input, input.value);
  //         input.classList.remove('is-danger');
  //         inputField.classList.remove('has-error');
  //       } else {
  //         errors.push(input.getElementsByTagName('name'));
  //         input.classList.add('is-danger');
  //         inputField.classList.add('has-error');
  //       }
  //       input.addEventListener('focusin', () => {
  //         input.classList.remove('is-danger');
  //         inputField.classList.remove('has-error');
  //       });
  //     });
  //
  //     legalCheckboxes.forEach((input) => {
  //       const inputField = closest(input, '.field');
  //       if (input.checked === true) {
  //         input.classList.remove('is-danger');
  //         inputField.classList.remove('has-error');
  //       } else {
  //         errors.push(input.getElementsByTagName('name'));
  //         input.classList.add('is-danger');
  //         inputField.classList.add('has-error');
  //       }
  //       input.addEventListener('change', () => {
  //         input.classList.remove('is-danger');
  //         inputField.classList.remove('has-error');
  //       });
  //     });
  //
  //     if (invoiceInputsTrigger.checked) {
  //       invoiceInputs.forEach((input) => {
  //         const inputField = closest(input, '.field');
  //         if (input.value) {
  //           input.classList.remove('is-danger');
  //           inputField.classList.remove('has-error');
  //         } else {
  //           errors.push(input.getElementsByTagName('name'));
  //           input.classList.add('is-danger');
  //           inputField.classList.add('has-error');
  //         }
  //         input.addEventListener('focusin', () => {
  //           input.classList.remove('is-danger');
  //           inputField.classList.remove('has-error');
  //         });
  //       });
  //     }
  //
  //     if (errors.length > 1) {
  //       event.preventDefault();
  //       event.stopPropagation();
  //
  //       return false;
  //     }
  //
  //     return true;
  //   });
  // }

  cart();
});

window.modal = (name, visible) => {
  return {
    status: visible,
    content: false,
    type: name,
    init() {
      this.$watch('status', (value) => {
        if (value) {
          this.content = true;
        }
        if (!value) {
          setTimeout(() => (this.content = value), 150);
        }
      });
    },

    open(type) {
      if (this.type === type) {
        this.status = true;
      }
    },
    close(type) {
      if (this.type === type) {
        this.status = false;
      }
    },
    change($dispatch, type) {
      this.close(this.type);
      $dispatch('modal:open', type);
    },

    validateAll(e) {
      let inputs = e.target.closest('form').querySelectorAll('input');

      inputs.forEach((input) => {
        input.closest('div').querySelector('.help').innerText = input.validationMessage;
      });
    },
    validate(e) {
      let input = e.target;
      input.closest('div').querySelector('.help').innerText = input.validationMessage;
    },
    resetForm(e) {
      let helps = e.target.closest('form').querySelectorAll('.help');

      helps.forEach((help) => {
        help.innerText = '';
      });

      e.target.closest('form').querySelector('input[type=reset]').click();
    }
  };
};

window.cardControl = () => {
  return {
    cardId: '',
    cardInputs: [],
    cardNumber: [ '', '', '', '' ],
    card: {
      amount: null
    },
    subscription: null,
    amount: null,
    errors: [],

    init() {
      this.cardInputs = Array.from(this.$el.querySelectorAll('input[name=card_number]'));
      if (this.$refs.amount) {
        this.amount = window.currencyFormatter(this.$refs.amount.selectedOptions[0].value * 1.1);
      }

      this.$watch('cardNumber', (val) => {
        this.cardId = this.cardNumber.join('');
        this.card.id = this.cardId;
      });
      this.$watch('cardId', (val) => {
        if (val.length == 16) {
          alert(`TODO: ${val} számú kártya lekérdezése`);

          if (this.errors.includes('card')) {
            this.errors.slice(this.errors.indexOf('card'), 1);
          }
        }
      });
      this.$watch('amount', (val) => {
        if (this.errors.includes('amount') && val != '0 Ft') {
          this.errors.slice(this.errors.indexOf('subscription'), 1);
        }
      });
      this.$watch('subscription', (val) => {
        if (this.errors.includes('subscription')) {
          this.errors.slice(this.errors.indexOf('subscription'), 1);
        }
      });
    },
    handleInput(index) {
      if (this.cardNumber[index].length >= 4) {
        this.cardNumber[index] = this.cardNumber[index].slice(0, 4);

        this.cardInputs[index + 1] ? this.cardInputs[index + 1].focus() : this.cardInputs[0].focus();
      }
    },
    validate() {
      if (this.cardId.length < 16) this.errors.push('card');
      if (this.amount == '0 Ft') this.errors.push('amount');

      let requiredInputs = Array.from(this.$el.querySelectorAll('input[required]'));

      requiredInputs.forEach((item) => {
        this.validateInput(item);
      });
    },
    validateSubscription() {
      if (this.cardId.length < 16) this.errors.push('card');
      if (!this.subscription) this.errors.push('subscription');

      let requiredInputs = Array.from(this.$el.querySelectorAll('input[required]'));

      requiredInputs.forEach((item) => {
        this.validateInput(item);
      });
    },
    validateInput(input) {
      let error = input.closest('.input-wrapper').querySelector('.help');

      error.innerText = '';
      if (!input.checkValidity()) {
        this.errors.push(input.name);
        error.innerText = input.validationMessage;
      }
    }
  };
};

window.newCard = () => {
  return {
    newCard: false,
    cardId: '',
    cardInputs: [],
    cardNumber: [ '', '', '', '' ],
    card: {
      amount: null
    },
    error: false,

    init() {
      this.cardInputs = Array.from(this.$el.querySelectorAll('input[name=card_number]'));

      this.$watch('cardNumber', (val) => {
        this.cardId = this.cardNumber.join('');
        this.card.id = this.cardId;
      });
      this.$watch('cardId', (val) => {
        if (val.length == 16) {
          alert(`TODO: ${val} számú kártya lekérdezése`);
          this.error = false;
        }
      });
    },
    handleInput(index) {
      if (this.cardNumber[index].length >= 4) {
        this.cardNumber[index] = this.cardNumber[index].slice(0, 4);

        this.cardInputs[index + 1] ? this.cardInputs[index + 1].focus() : this.cardInputs[0].focus();
      }
    }
  };
};

window.cardManagement = () => {
  return {
    cards: null,
    pickedCard: null,
    cardsHaveSubscription: [],

    init() {
      this.cards = JSON.parse(cardsData);
      this.pickedCard = this.cards[0];
      this.cards.forEach((item) => {
        if (item.subscription.is_subscribed) this.cardsHaveSubscription.push(item);
      });
    },
    pickCard(value) {
      this.cards.forEach((item) => {
        if (item.id == value) this.pickedCard = item;
      });
      console.log(this.pickedCard.id);
    },
    formatId(value) {
      return `${value.substring(0, 4)} - ${value.substring(4, 8)} - ${value.substring(8, 12)} - ${value.substring(
        12,
        16
      )}`;
    }
  };
};

window.currencyFormatter = (value) => {
  return new Intl.NumberFormat('HU-hu', {
    style: 'currency',
    currency: 'HUF',
    maximumFractionDigits: 0
  }).format(value);
};

window.dateFormatter = (value) => {
  return new Date(value).toLocaleString('HU-hu', { year: 'numeric', month: 'numeric', day: 'numeric' });
};

window.disableCard = (card) => {
  alert(`TODO: ${card.id} id-jú kártya inaktiválása`);
};

window.captchaButton = function({ siteKey }) {
  return {
    token: null,
    init($dispatch) {
      this.$watch('token', (value) => $dispatch('input', value));

      grecaptcha.ready(() => {
        grecaptcha.render(this.$el, {
          sitekey: siteKey,
          size: 'invisible',
          callback: (token) => {
            this.token = token;
            this.$el.click();
          }
        });
      });
    },
    trigger: {
      ['x-on:click.prevent']() {
        if (this.token) {
          this.$el.click();

          return;
        }

        grecaptcha.execute();
      }
    }
  };
};

window.card = function(callback) {
  return {
    cardNumber: null,
    cardNumbers: [ null, null, null, null ],
    next(i) {
      if (this.$refs[`inputs-${i + 1}`] !== undefined) {
        this.$refs[`inputs-${i + 1}`].select();
      }
    },
    previous(i) {
      if (this.$refs[`inputs-${i - 1}`] !== undefined) {
        this.$refs[`inputs-${i - 1}`].focus();
      }
    },
    paste(value) {
      this.cardNumbers = value.match(/(\d{4})/g);
    },
    init($dispatch) {
      this.$watch('cardNumbers', (value) => (this.cardNumber = value.join('')));
      this.$watch('cardNumber', (value) => {
        if (value.length === 16) {
          callback(value);
        }
      });
    }
  };
};

window.zipCoder = function() {
  return {
    zip: null,
    city: null,
    init() {
      this.$watch('zip', async function(zip) {
        if (zip.length === 4) {
          const response = await fetch(`https://hu-zips.now.sh/?zip=${value}`);
          const { data: places } = await response.json();

          if (places && places.length === 1) {
            this.city = places[0]['city'];
          }
        }
      });
    }
  };
};

window.slider = function(options) {
  return {
    options,
    slider: null,

    init() {
      this.slider = new Glide(this.$refs.slider || this.$el, options);
      this.slider.mount();
    }
  };
};

let cardsData =
  '[{"id":"1234567843218765","amount":"3500","subscription":{"is_subscribed":true,"type":"1","next_payment":"2021-12-31"},"transactions":[{"type":"1","name":"Előfizetés jóváírása","date":"2021-10-03","amount":"1500","balance":"3500","link":"null"},{"type":"1","name":"Vásárlás","date":"2021-09-21","amount":"-1500","balance":"3500","link":"null"},{"type":"1","name":"Vásárlás","date":"2021-09-17","amount":"-1500","balance":"3500","link":"null"},{"type":"1","name":"Új kártya regisztrálása","date":"2021-08-28","amount":"5000","balance":"5000","link":"null"},{"type":"2","name":"Előfizetés ingyenes jóváírás","date":"2021-09-28","amount":"1500","balance":"6000","link":"#"},{"type":"0","name":"Előfizetés havi - 3. alkalom","date":"2021-08-28","amount":"1500","balance":"4500","link":"#"},{"type":"0","name":"Előfizetés havi - 2. alkalom","date":"2021-07-28","amount":"1500","balance":"3000","link":"#"},{"type":"0","name":"Előfizetés havi - 1. alkalom","date":"2021-06-28","amount":"1500","balance":"1500","link":"#"}]},{"id":"1234123412341234","amount":"500","subscription":{"is_subscribed":false,"type":"1","name":"null","next_payment":"null"},"transactions":[{"type":"1","name":"Új kártya regisztrálása","date":"2021-08-28","amount":"5000","balance":"5000","link":"null"}]}]';



// WEBPACK FOOTER //
// ./resources/assets/js/app.js